var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("基本料金")]),_c('v-card-text',{staticClass:"mt-n4"},[_c('c-divider'),_c('c-total-row',{attrs:{"label":"基本料金 小計","charge":_vm.charge.basic}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }